var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-spinner-progress"},[_c('spinner',{attrs:{"animation-duration":_vm.animationDuration,"size":_vm.circleSize,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }